import { router } from "@inertiajs/react";
import { useEchoSubscription } from "@/components/WebSocketEcho";
import { notifications } from "@/Logigate/componentes/notificacoes";
import { Botao } from "@/Logigate/ui";

interface BackfillNotificationData {
    backfill_id: number;
    tarefa_id: number | null;
    estado: "ok" | "erro";
    simulacao: boolean;
    texto: string;
    url: string | null;
}

interface UseBackfillNotificationOptions {
    channelName: string;
    enabled?: boolean;
}

/**
 * Aviso do fim da reconstrução da contabilidade.
 *
 * Um backfill de um exercício inteiro demora bastante e ninguém fica à espera com a
 * página aberta — daí ir pelo canal privado do administrador, o mesmo que já serve as
 * exportações, e não por polling na página. É o `notifications` do `@/Logigate/componentes`
 * (o gémeo Tailwind do Mantine), montado fora da árvore da página: o botão navega pelo `router`.
 */
export function useBackfillNotification({ channelName, enabled = true }: UseBackfillNotificationOptions) {
    useEchoSubscription({
        channelName,
        enabled: enabled && !!channelName,
        events: {
            BackfillContabilidadeConcluido: (data: BackfillNotificationData) => {
                const ok = data.estado === "ok";
                const url = data.url;

                notifications.show({
                    title: ok
                        ? data.simulacao
                            ? "Simulação da reconstrução concluída"
                            : "Reconstrução da contabilidade concluída"
                        : "Reconstrução da contabilidade falhou",
                    message: (
                        <>
                            <p>{data.texto}</p>
                            {url && (
                                <div className="mt-2.5 flex flex-wrap gap-2">
                                    <Botao tamanho="sm" cor={ok ? "green" : "red"} className="max-md:h-10" onClick={() => router.visit(url)}>
                                        Ver o registo
                                    </Botao>
                                </div>
                            )}
                        </>
                    ),
                    color: ok ? "green" : "red",
                    autoClose: 20000,
                    withCloseButton: true,
                });
            },
        },
    });
}
